import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-table-skelton',
  standalone: true,
  imports: [SkeletonModule, TableModule, CommonModule],
  templateUrl: './table-skelton.component.html',
  styleUrl: './table-skelton.component.scss'
})
export class TableSkeltonComponent {
  @Input() isOrderHistory: boolean = false;

}
